var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14, _path16, _g15, _path17, _g16, _path18, _g17, _path19, _g18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 52,
    viewBox: "0 0 120 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 0,
    width: 13,
    height: 5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.662 4.96083H72.2833C72.2672 4.94567 72.2511 4.93004 72.2341 4.91441C71.0669 3.86379 71.3568 3.85196 72.6675 3.38349C73.9781 2.9155 74.3107 1.00562 74.3334 0.936463C74.4746 0.502573 74.6697 0.359538 74.8843 0.359538C75.0425 0.359538 75.2111 0.437205 75.3764 0.532888C75.5806 0.651781 75.8691 0.756937 76.2129 0.756937C76.5237 0.756937 76.8794 0.67122 77.2588 0.432486C77.6728 0.171489 77.9324 4.76837e-07 78.1408 4.76837e-07C78.3346 4.76837e-07 78.4842 0.148263 78.6728 0.511101C78.9939 1.12925 79.8977 1.33719 80.9616 1.33719C81.1089 1.33719 81.2595 1.33294 81.4121 1.32584C81.4987 1.32157 81.5868 1.31637 81.6749 1.30974C81.7555 1.30405 81.8289 1.3012 81.8957 1.3012C82.9543 1.3012 82.3717 2.01741 82.4271 2.80608C82.4868 3.64449 83.0496 4.46206 83.5389 4.81731C83.5976 4.85995 83.6374 4.90778 83.662 4.96083Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_10951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.662 4.96083H72.2833C72.2672 4.94567 72.2511 4.93004 72.2341 4.91441C71.0669 3.86379 71.3568 3.85196 72.6675 3.38349C73.9781 2.9155 74.3107 1.00562 74.3334 0.936463C74.4746 0.502573 74.6697 0.359538 74.8843 0.359538C75.0425 0.359538 75.2111 0.437205 75.3764 0.532888C75.5806 0.651781 75.8691 0.756937 76.2129 0.756937C76.5237 0.756937 76.8794 0.67122 77.2588 0.432486C77.6728 0.171489 77.9324 4.76837e-07 78.1408 4.76837e-07C78.3346 4.76837e-07 78.4842 0.148263 78.6728 0.511101C78.9939 1.12925 79.8977 1.33719 80.9616 1.33719C81.1089 1.33719 81.2595 1.33294 81.4121 1.32584C81.4987 1.32157 81.5868 1.31637 81.6749 1.30974C81.7555 1.30405 81.8289 1.3012 81.8957 1.3012C82.9543 1.3012 82.3717 2.01741 82.4271 2.80608C82.4868 3.64449 83.0496 4.46206 83.5389 4.81731C83.5976 4.85995 83.6374 4.90778 83.662 4.96083Z",
    fill: "url(#paint0_linear_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 5,
    width: 29,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7894 23.9994C40.7894 23.9994 23.7977 23.7592 13.5004 11.2588C12.3801 9.89843 12.3635 7.94025 13.4828 6.5789C15.1516 4.54825 18.3437 4.88503 19.5654 7.21268C22.0474 11.9424 27.7439 18.7169 40.7894 23.9994Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_39_10951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7894 23.9994C40.7894 23.9994 23.7977 23.7592 13.5004 11.2588C12.3801 9.89843 12.3635 7.94025 13.4828 6.5789C15.1516 4.54825 18.3437 4.88503 19.5654 7.21268C22.0474 11.9424 27.7439 18.7169 40.7894 23.9994Z",
    fill: "url(#paint1_linear_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 34,
    width: 21,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8882 34.5643C38.8882 34.5643 25.9416 36.4709 19.349 47.0571C18.6318 48.2086 18.818 49.7054 19.8099 50.631C21.2901 52.0118 23.6926 51.431 24.3889 49.5306C25.8038 45.6683 29.4653 39.9192 38.8882 34.5643Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_39_10951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8882 34.5643C38.8882 34.5643 25.9416 36.4709 19.349 47.0571C18.6318 48.2086 18.818 49.7054 19.8099 50.631C21.2901 52.0118 23.6926 51.431 24.3889 49.5306C25.8038 45.6683 29.4653 39.9192 38.8882 34.5643Z",
    fill: "url(#paint2_linear_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 26,
    width: 37,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6633 29.7726C36.6633 29.7726 19.1504 33.2555 7.74902 37.5205C5.122 38.5034 2.17383 37.4433 0.774112 35.0129C-1.40907 31.223 1.28045 26.4895 5.65392 26.4156C14.8755 26.2598 28.5653 26.6472 36.6633 29.7726Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_39_10951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6633 29.7726C36.6633 29.7726 19.1504 33.2555 7.74902 37.5205C5.122 38.5034 2.17383 37.4433 0.774112 35.0129C-1.40907 31.223 1.28045 26.4895 5.65392 26.4156C14.8755 26.2598 28.5653 26.6472 36.6633 29.7726Z",
    fill: "url(#paint3_linear_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 9,
    width: 4,
    height: 4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8217 12.9248C61.5399 12.9248 61.2874 12.7429 61.1737 12.4814C60.9302 11.9182 60.2003 11.6184 60.3173 10.8283C60.3898 10.3323 60.9591 9.82125 61.4844 9.82125C61.6341 9.82125 61.781 9.86291 61.9112 9.95812C62.0197 10.0382 62.1481 10.0723 62.2793 10.0723C62.4114 10.0723 62.5469 10.0377 62.6696 9.97945L62.6805 9.97424C62.7705 9.93256 62.8647 9.91314 62.958 9.91314C63.2342 9.91314 63.5009 10.0837 63.6221 10.3513L63.6529 10.4275C62.977 11.1347 62.9922 12.8499 61.8643 12.9238C61.8501 12.9248 61.8359 12.9248 61.8217 12.9248Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_39_10951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.0862,
    y: 9.70235,
    width: 3.6568,
    height: 3.3726,
    fill: "url(#pattern0_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 33,
    width: 17,
    height: 11
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4065 43.7077C85.9911 43.7077 85.6377 43.5949 85.391 43.3055C84.1878 41.8949 83.8146 41.7703 82.1553 40.8164C80.4955 39.8619 80.0393 39.3228 80.5784 37.4973C80.7911 36.7773 80.4751 35.7286 80.1511 34.6765L89.7071 33.6534L94.7234 33.1167C94.7731 33.2977 94.8252 33.4753 94.8797 33.6472C95.0691 34.2431 95.2927 34.7717 95.5968 35.1327C96.9241 36.7091 94.6424 38.5758 94.8498 40.8576C94.9754 42.2393 94.0815 42.6173 93.1176 42.6173C92.4895 42.6173 91.832 42.4572 91.4062 42.3099C91.3375 42.2862 91.2575 42.2748 91.1679 42.2748C90.6573 42.2748 89.8369 42.6329 88.9592 42.9915C88.081 43.3496 87.1459 43.7077 86.4065 43.7077Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_39_10951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.8385,
    y: 33.0073,
    width: 17.2514,
    height: 10.8567,
    fill: "url(#pattern1_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 4,
    width: 12,
    height: 8
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9718 11.85C76.0553 11.85 75.5044 10.4692 74.4533 10.4313C73.2871 10.3892 73.3889 8.17378 72.371 7.66647C71.3677 7.16674 73.3416 6.00007 72.2834 4.96082H83.6621C83.8421 5.35018 83.1822 6.02046 82.8582 6.94745C82.4897 8.00091 83.6559 8.41583 82.8777 8.70856C82.0994 9.00177 81.3628 9.61899 81.063 10.9855C80.9209 11.6321 80.3179 11.7652 79.6036 11.7652C79.3544 11.7652 79.092 11.7491 78.8306 11.733C78.5696 11.7164 78.31 11.7003 78.066 11.7003C77.7989 11.7003 77.5507 11.7197 77.3413 11.7799C77.3233 11.7851 77.3053 11.7908 77.2878 11.7965C77.1774 11.8334 77.0722 11.85 76.9718 11.85Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_39_10951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.2175,
    y: 4.82342,
    width: 12.7988,
    height: 7.20938,
    fill: "url(#pattern2_39_10951)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0449 26.4445L46.5082 30.7706L66.3529 36.1539V36.1525L66.3534 36.1535L138.755 28.4022L136.702 9.23105L64.3009 16.9823L64.3005 16.9832V16.9823L46.0449 26.4445Z",
    fill: "#FBC821"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 10,
    width: 57,
    height: 27
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3535 36.1535L65.39 27.1526L65.2247 25.6089L65.9258 25.5331L71.5242 24.9339L72.6529 35.4794L66.3535 36.1535ZM80.0575 34.6865L78.9287 24.1415L88.578 23.1079L89.7072 33.6534L80.1512 34.6765L80.0575 34.6865ZM112.988 31.1609L111.859 20.6159L120.201 19.7225V30.3888L112.988 31.1609ZM64.4664 18.5246L64.301 16.9823L120.201 10.9974V12.5577L111.1 13.532L110.936 11.9893L87.6543 14.4817L87.8196 16.0245L78.1703 17.0576L78.005 15.5148L70.6005 16.3078L70.7658 17.8501L65.1674 18.4497L64.4664 18.5246Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_39_10951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3535 36.1535L65.39 27.1526L65.2247 25.6089L65.9258 25.5331L71.5242 24.9339L72.6529 35.4794L66.3535 36.1535ZM80.0575 34.6865L78.9287 24.1415L88.578 23.1079L89.7072 33.6534L80.1512 34.6765L80.0575 34.6865ZM112.988 31.1609L111.859 20.6159L120.201 19.7225V30.3888L112.988 31.1609ZM64.4664 18.5246L64.301 16.9823L120.201 10.9974V12.5577L111.1 13.532L110.936 11.9893L87.6543 14.4817L87.8196 16.0245L78.1703 17.0576L78.005 15.5148L70.6005 16.3078L70.7658 17.8501L65.1674 18.4497L64.4664 18.5246Z",
    fill: "url(#paint4_linear_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 18,
    width: 2,
    height: 8
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2242 25.6089L64.4658 18.5246H64.4663L65.2247 25.6089H65.2242Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_39_10951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.1124,
    y: 18.0864,
    width: 1.43052,
    height: 7.77779,
    fill: "url(#pattern3_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 12,
    width: 57,
    height: 14
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2247 25.6089L64.4663 18.5246L65.1673 18.4497L70.7657 17.8501L71.5241 24.9339L65.9257 25.5331L65.2247 25.6089ZM78.9286 24.1415L78.1703 17.0576L87.8196 16.0245L88.5779 23.1079L78.9286 24.1415ZM111.859 20.6159L111.1 13.532L120.201 12.5577V19.7225L111.859 20.6159Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_39_10951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.1124,
    y: 12.2128,
    width: 56.4719,
    height: 13.6514,
    fill: "url(#pattern4_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 31,
    width: 19,
    height: 3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7234 33.1167C94.7234 33.1162 94.7234 33.1163 94.7229 33.1163L112.988 31.1609V31.1614L94.7234 33.1167Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_39_10951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.6173,
    y: 30.9705,
    width: 18.4829,
    height: 2.33051,
    fill: "url(#pattern5_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 33,
    width: 6,
    height: 1
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7072 33.6534L94.7229 33.1163C94.7234 33.1163 94.7234 33.1162 94.7234 33.1167L89.7072 33.6534Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_39_10951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.5016,
    y: 33.0073,
    width: 5.4094,
    height: 0.72,
    fill: "url(#pattern6_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 11,
    width: 26,
    height: 23
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7072 33.6534L88.578 23.1079L111.859 20.6159L112.988 31.1609L94.723 33.1163L89.7072 33.6534ZM87.8196 16.0245L87.6543 14.4817L110.936 11.9893L111.1 13.532L87.8196 16.0245Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_39_10951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7072 33.6534L88.578 23.1079L111.859 20.6159L112.988 31.1609L94.723 33.1163L89.7072 33.6534ZM87.8196 16.0245L87.6543 14.4817L110.936 11.9893L111.1 13.532L87.8196 16.0245Z",
    fill: "url(#paint5_linear_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 13,
    width: 25,
    height: 11
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5779 23.1079L87.8196 16.0245L111.1 13.532L111.859 20.6159L88.5779 23.1079Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_39_10951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.5594,
    y: 13.1128,
    width: 24.5934,
    height: 10.2883,
    fill: "url(#pattern7_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 15,
    width: 11,
    height: 21
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6528 35.4794L71.524 24.9339L78.9285 24.1415L80.0573 34.6865L72.6528 35.4789M70.7656 17.8501L70.6003 16.3078L78.0049 15.5148L78.1702 17.0576L70.7656 17.8501Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_39_10951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.6528 35.4794L71.524 24.9339L78.9285 24.1415L80.0573 34.6865L72.6528 35.4789M70.7656 17.8501L70.6003 16.3078L78.0049 15.5148L78.1702 17.0576L70.7656 17.8501Z",
    fill: "url(#paint6_linear_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 17,
    width: 9,
    height: 8
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5241 24.9339L70.7657 17.8501L78.1703 17.0576L78.9286 24.1415L71.5241 24.9339Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_39_10951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.5071,
    y: 16.7128,
    width: 8.67778,
    height: 8.48831,
    fill: "url(#pattern8_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 16,
    width: 21,
    height: 21
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3529 36.1539L64.3005 16.9823V16.9832L64.4658 18.5246L65.2241 25.6089L66.3529 36.1525V36.1539ZM60.9814 34.6969L46.5082 30.7706L46.0449 26.4445L55.8581 21.3577L58.0901 33.9125L60.9814 34.6969Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_39_10951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3529 36.1539L64.3005 16.9823V16.9832L64.4658 18.5246L65.2241 25.6089L66.3529 36.1525V36.1539ZM60.9814 34.6969L46.5082 30.7706L46.0449 26.4445L55.8581 21.3577L58.0901 33.9125L60.9814 34.6969Z",
    fill: "url(#paint7_linear_39_10951)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_39_10951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 16,
    width: 12,
    height: 21
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.353 36.1539L60.9814 34.6969L58.0901 33.9125L55.8582 21.3577L64.3005 16.9823L66.353 36.1539Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_39_10951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.4915,
    y: 16.5233,
    width: 11.1883,
    height: 20.0461,
    fill: "url(#pattern9_39_10951)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_39_10951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_39_10951",
    transform: "scale(0.03125 0.0344828)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_39_10951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_39_10951",
    transform: "scale(0.00662252 0.0105263)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_39_10951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_39_10951",
    transform: "scale(0.00892857 0.015873)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_39_10951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_39_10951",
    transform: "scale(0.166667 0.0294118)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4_39_10951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4_39_10951",
    transform: "scale(0.00403226 0.0166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5_39_10951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image5_39_10951",
    transform: "scale(0.00617284 0.05)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6_39_10951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image6_39_10951",
    transform: "scale(0.0212766 0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7_39_10951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image7_39_10951",
    transform: "scale(0.00925926 0.0222222)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern8_39_10951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image8_39_10951",
    transform: "scale(0.0263158 0.027027)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern9_39_10951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image9_39_10951",
    transform: "scale(0.0204082 0.0113636)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_10951",
    x1: 42.1612,
    y1: -27.4113,
    x2: 100.925,
    y2: 26.8159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF2778"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39_10951",
    x1: 34.7207,
    y1: 28.3079,
    x2: 17.2705,
    y2: 3.72864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42C2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_39_10951",
    x1: 33.8184,
    y1: 31.8909,
    x2: 22.9905,
    y2: 52.4228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42C2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_39_10951",
    x1: 22.433,
    y1: 38.4712,
    x2: 12.0858,
    y2: 21.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF2778"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_39_10951",
    x1: 100.629,
    y1: 12.2351,
    x2: 102.216,
    y2: 30.7086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC621C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322259,
    stopColor: "#EE7017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85271B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_39_10951",
    x1: 100.629,
    y1: 12.2351,
    x2: 102.216,
    y2: 30.7086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322259,
    stopColor: "#D9521E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#762019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_39_10951",
    x1: 100.629,
    y1: 12.2351,
    x2: 102.216,
    y2: 30.7086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322259,
    stopColor: "#D9521E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#762019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_39_10951",
    x1: 56.5483,
    y1: 14.2757,
    x2: 56.1722,
    y2: 32.6017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC621C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322259,
    stopColor: "#EE7017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85271B"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_39_10951",
    width: 32,
    height: 29,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAdCAYAAADLnm6HAAAABHNCSVQICAgIfAhkiAAAAK1JREFUSInF1ksKhTAMQNHb7u7tz7W5nPYNBEGaaFvyyVCRcwWjlt9xdrRp+ilpeini8dKaek3NxPWAIFwOCMTHgGD8GWCEr061xlfu/gpIxK8Ao9nBlwMsHrrtAA98OsALnwrwxD8DvPHXgAicrgRE4SAEROJDQDT+CLD6uKzgd4D1+30WB6iZOLysYQSuBkThYkAkPgSYrtvk3AGeu/4ZkIUD1EwcDP8Jd3CAPzqraIy9BXQcAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_39_10951",
    width: 151,
    height: 95,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_39_10951",
    width: 112,
    height: 63,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAA/CAYAAAA47kzyAAAABHNCSVQICAgIfAhkiAAAAiNJREFUeJzt3FGSwiAQhOGOJ9kz7sH3CvriWppIMgwD9CT9P1sl5FNDsIrl7+f3DktL8wv6NOltq1rWg7Rdcks32wCaX9Cni+MBFkDh+euMBxwBCs/fADxgD1B4/gbhAdZ74CbhFRuIB5QAdy+U8IoNxgO+AQovqP54wBpQeP4+vn1j8IB3QOH5m4QH/AMKz9/mvje2W5oLxdiERcu6g8cIffuKEeABu4DCK0aCBxQBhVeMCA/4Cii8YmR4wAZQeMUI8YAPQOEVI8UDXoDCK0aMBwA34e1Ejge4/05qLAPeJj48YAZgFryJ+5vmlmUwoPDieo5xHGBKPNLexjjnHshagkXLeoxjABN8qDPiASMAhRdT4ae9L6DwYtq5L/cDFF5MB4uqPoDCG1Y8oPDiMjzSxAIKLy7j82gcoPDiqthMiAHMgLcpPx7uEYBZ8BLtb5p6TqENUHhxOfCAFsCUeKQ58YCzb2ZnWLQ04AFewAQf6ivgAR5A4cUU9NNeByi8mGrxdqZgBxReTIF4QNhBPwRlwKvNMIWAg34IyoIXsGhZ13jQD0EXxgOaDvoh6OJ4gOucGNauhwdUnxND1In3N2uqOCeGKOG9yrcXevLN6dqMB/2QlGHRMhAPMB30Q5LwvpbjoJ+z4QXGfw88I17gFLgBhXcYL2AGvNo6TIETMAvehEXLOj5A4VXFBSi86rgAPxKeJR5A7W+64gAUnrv5gNqcbuoBL2ZZuCqLONAAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_39_10951",
    width: 6,
    height: 34,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAiCAYAAAB88ahoAAAABHNCSVQICAgIfAhkiAAAAIRJREFUKJF9kkEShDAIBBuLf/r/+3pTxou1RmWSU4rOMBCI7beK5uRCGydxICg6mAt7D0Q5j33m0QKjQF25IiWnKFfVK1X8zct9yUNx301VkNJoPijiAqF4Kjh0vdULOI+QaVBWcbRxEvUkzZxInDl8U6kgzZwmDZoNnZmPqTQOyi6DASdaoEluLDpDYQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image4_39_10951",
    width: 248,
    height: 60,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image5_39_10951",
    width: 162,
    height: 20,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKIAAAAUCAYAAAAOYeZzAAAABHNCSVQICAgIfAhkiAAAA9NJREFUaIHNmlGC3CAIhiGTa/RwvWEvuNqHmbgEAX/UdMtDdxIBjX4BNOU/v39VWpGyZP248PUDeUrGVYeueKwz29ERtEXLAY0J6Ef2wfX+d+jEGeCJD2swoh+Q1LyCyhCvq5Cx+ivkCOyK+muNB50TCzLt97rWurdr+SwGDx2gTFSNQc6D+CCEyRd3m1R6FrLIdf38swoZEsXktdSPIq3lsJsrA7JKRCwdf9nRcw7EBQgfgWy4wljHXGkKMqR7/Vvb8cgRYZBBUQwQNgyKTMOH4dSAjA+6PXh9qfZPWx7EAMJ/DlnCPkx5K1GMAMAAh9b4plLlQCLAbnqG7cFE9CV0lJ0HmXeP+bsjCET2ZnxVNpFrubnGfEFWAsgs+zRkzrN4j1jVxXKqJAyyWj9AyX4y6/CBLQNZJ3pymeh0dzueMSIPAiYlguWqVVAfWncXZF5l0F4CcF4RyNwotkHa7jh6e4nebxTTpzj0nPUusNTsrdaCzKQ8okHx7ixqVFt5m5MoSuprD7KRcN2QKjdKGIH1onjKn/vu0Jz1u4Fobas5InvcVycIZKa9Y+iBKVPx7dzL+Y1All13C5Q2rvKe7+VUiY4lo6z7vzYnRpNnl32E04KvOQNCvxQ3VaJRLIBMGrom4ERY79ZWyGRH2i6xi4fGkVEe9BkGgAXIEGkRsXug2v+cTpUgYFoVqt8ScvA77UX2EGBEMWSX6GdjIk4cfT0OGaLzyFFI77qB2B2k0nqqRKJYOjIZn4xMeLx6UelqyAr1QJlHPwZkt2arzhOTvAsyuB7N9LdBkM2elFMXy1zoEcjSgF231RiKcVGAOqtcO7mBf1LHDghg8r4LGABzsjmtBzsb7OQzkMn5uNXqyu7kYuzcfgKy6qTAyCaxAodRGEJRTNzLnuvdHYWXiMm6IOAnalgLMg2Y3GSr8+6bnHQIwMqGVElGlJmBLCuO/3ae+CRk42FM6+1yBkUx8bJe8xFFMbGZ9iEDNzlna9RF4kyqvO4xWGchkgj93TiI6LXxaxB8dLHzC9QuyIzmLrmoTDiKYtbBtCUW1HrdzlYTHBtSZVYWILPM9VBS32CBBuu/NLk2yLxkasQkkC3DgmWR5ywLWTTnflulM5qw/wWyzPpr/akoNupgIPUYH9PMQnYbJlgWDcdg9G/Vf3nIvju/No/yNKNtKJnoTMP2cBSz3CNcRGlmN2QjObxPOYNud0G2I1Va+l7nGjIJmFZ/OR3dvzU/CFl2/d0Fcho0fFAnSkaQHRWs/4y0lkqV0sB27UqXKi2D+t6VRKlS27qQiXF6kDX9oP0v87Qbr3aFKdAAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image6_39_10951",
    width: 47,
    height: 6,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAGCAYAAABThMdSAAAABHNCSVQICAgIfAhkiAAAAIRJREFUOI2t0sENgCAMBdBf00WcyFncPwEPxEDhUyvaC1KkPBpkP84MGpO0CM+zXwPlvoSaqgbmI+NXwDp8aJQtpKyTr2BPMYObc6O3szL9FQpYVAYgDNaf2s3Z00zN91YGXYYByKRjUhdjsGSnN2wIkq/4pihDEQbE66AEYROs/yLKpgt0EhMTKnEwWAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image7_39_10951",
    width: 108,
    height: 45,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image8_39_10951",
    width: 38,
    height: 37,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAlCAYAAAAuqZsAAAAABHNCSVQICAgIfAhkiAAAAnFJREFUWIW1WEuW3CAMLHm0nfsfIqfLNmNLWTQwGEsF9CTa9QOVSn/a8vvXpyOTj/TkfZG1a/pj44uGVsQ/vmOk/8OQ9RgjXp6fm6L6eJkpAvASYWf3EjyxHG8Udc/JWBS+sxghxDJjoTNnQgyXIHDkDhjwy3iJ58aAhHRAQE9SVC0qs/R2EJOrwEXsdFgqwUU7XjU7NTKwiWrIDq76sFN+PLsSwGEIw9t0E2ORIxHZkVgkiguw43ksLF6JMfEYKyXlnlpRg4SGHEnhELsO0EgDQyNFXVWJ+awlQ+vdz5LWWcpmUGN5qBPWS3I9jTRh0KPC0IT6GHrM82yvZoWSDjtio3XlmJougsd4mAzOaCQI2Sgz8QPQ28a1zplj7BgyiJMo12z4wVfYTafwUA8GLADgIvGeDE0U8Co7jVGttlRmQzMEzpzp5J2mkq7gtXr2TrtTIwNepUmfS125qJQay3jR2thwpr0HFiOp1tfCQop2xOROokUxcHaMsOKUdnGlcap+GknLI9KrWHZQibklYM7rYXdEGevyQNT+xAqv/wIcjKV+i3gXvvZQ9HPNkyh66cbZjM5NtwC/amzKau1fXfoSZ5FNgNXJH4cMSJKaXDI+GTH1uO1KPvieHFp3/sMt0HNQKxG7e8WBeoCZP9ThzI441IbDBjQhNwJt6wAkrQLFl/CpsLR2vgHkWlMR59OopfJdgF4MsrbWfPJtBYA6mTmOtQdeawSLDTqSciESPhR7IFvt1mvjo9EKMSsDNry7s1dK2FxIBmyOWT+LPbqySn2GzCI2S8vs+9v9u0X3UByLfzRUa+yxbkhHsKdR6Ic9z/8CsB8jLt3jw80AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image9_39_10951",
    width: 49,
    height: 88,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAABYCAYAAABcZx+OAAAABHNCSVQICAgIfAhkiAAACndJREFUeJzVW1uS5LgNTGh0Ch/QF/cpvF0k/EE8EhBLqpmeCe8yQi2JpEAk3pSq5T///pcCAAQoZ2tz5rXqOtb1mjgAQIE5BFMFcwBjAjoFCuCvscbHBF5T8LLxORatvyYwBvA1FGMAYy4ar6F4zbX+mIqv17ofU3O+Av+F4sBDk5+8vzwvOYkuP16vD4hdCE08HimLppJo3uUxAZbsrV/qHKH7w+9b3yGLxTUmMS/Wk/35rIzoWyDQxaIIsC4UqlKtUIg5Rcx3RkUU4owamUMAPYBjCqbYfaNzGMciasLxVdVA7BhvmlF1KUuMqRpToWe11R3Muncpq0lXYtykD2Cy5ozcAWCKm6PgEMVkjfjziuYTQgd3+8JuLiQptEfEpJOS57lr7DCJiwByGEMCHAdi3PuqSUquSWufbOfYXKv9EXErUigk7q232Dg/H2ZlzE3WHvUfsjRyCJlhP9DBSWjkPmyQdqTNi9uqisX5holO7+j0miUE7XItlR8A52Eqf9fEqZtE1cTreUIEUFVMEQzRFWHEcgqW5JdPCI5j2bAeRmuaVA8EcZXlCz/MhxbNKgS1hdV4P+4ApOCqZBcNRQ8KRZKmjbD9PhdEj82FBc597jcgHozWeRX7RhPhGG8mwZmUCKMrhmrMF0javnOmV0AOKucZTWIo/WuBOreaoD7nIwRpjunlhzMPIMwo+PMFAVO9hESXqa3rIRv7hzOrEWrd+XtU3Ce75ryAB0dEosvxxbl6ZiJAwPKBSXRctSISY57gDuCiLbEcccDO5gOZN4TyxAYAoz04/tPR57kPsSNGciKbfmf3XRsHj6HO9yCyz9jMnNtGs3FmPkyHDm0yYZCRwdnNZD+vMN4Ahzld/LRrwvhWdWlYsvMJXQbktJkQGxoWEIEpzEqpYrYA3OfO40fjot3G2rL2EIsxXZJW4IeuUnh6GD5o/lzHGlrIPEpB0h/gDJMaNHzC0WZggJmrYJUqV010MEL30jDqVRH5TKhuK5woGJ+a07r05fnUTqjPN+NWlRjKs2z5W50S2rqj/zva+USzM3rlS6jPrt9pKIl+poUP2/kkKSXuGcA7cLxh/wNC37aqiQ0gAd6bkRdt1sdAdpb0p9qpvNIFhEB916Ap3f7Izva1qu2PIruaE3C1Vy2nKwq+Vr79fXZ/186dg2ljRLf9AHS9a/L3UdPmTzXNKdY4qg9NBaauPcm6tmeJvu8ILc0UWa1sLjigmJBNdGqSdYwXAK0vBrrW2rWzoX0uBY5PrE5pxrll5M29WpFUQJgWVljNENswhcTLW8Q2d/cMh2uNIq6CuckTnKoBqJQF+uJb0H5MBroWVkgxlS792chVIFUA53zI2AeHU15MEbbWbZ7NxX2FF3YABShSW1MrqF2QYz4/yNidSFdnZ7D2zXYOCbLjauHpQnvN1Uu/09uHWCakiZwB3DquXgF3s7n4TnPs1MaeQaW/jwUgLETtmFa1/cakmmm2yHMxu7ZE96Hm+C6QoLXh8Ryvp4R0M67A18CK93afUcjyxBTotD5y8KF57aB9N8e7uj5vqgeGBP1oTreNmAXWBxH13Q42H2iAiyZK/cVBgPrf8Rg+Mb8JYrLpELOTGFO6ZtPy8zZ/0DGJHho9heKc/j5Ff+FsppYMS1m0LDhxGXPTCxraQmwA03zWrzVNKh27O82H52EfF9zOL6CaTRdNmSS9/pqoYKIvlkswfD7ZHH76TIxyvA/HBjsjlimxhgqzmrRCylK0U0oXAvVtn2Am01almJMHgGBkMhBpZ9aYktwoItEx8d3ohObYnk+atC8bJJATW0nO8328BATaY1Z/Ac4xv7lxaU44sSTt4L48N0y1b9IS46EB0J4C1S/itZMBiFziL9jUo9N3MJDtl9qJNRAmJzU8NmePZxqN3AKQY9Na3/MJVPXzDo1jvzv6nCsShaZQAU1z8BqZnHGOTLpihKE455Rv5InV3LH9POz1paKWDRFKSRsl8kCLMLpAapQysAKcHtu/E2bhi9IiCmTNRNIfM/0GnbF5ZXIqMJxh5aSXWjvHHYMfAPAN/S6eA4JhxhsgDUDmFDMxZ5BMqjq7YiDvlca+7RP+tadn2bR1qb6BPJJJrVosNLQEg9AS0bm+KPjJFkIgRkGM+xg7OvtPiUjW4f1ozzitmGUTTx33eWI+oKxSdyBqjr18Qckfhq7fLMX+g3MGgMmhlEGMKhSBwN9PnsOpvQlBgvvoVTNrhtCQpDvrzJBYtGNEshRZxMLsWBMECpolyTk8Ler+XL5xbM6eKycxnIlovaHLaJKRJuZNDd8YZv/DtAais7SkpLH0ofXK5obJp6JkmErSsb0aXecxySGN4dF9hJx6sAC6s2szXw+xT479VJVMe3O+hCEEBGEymQNWKJ2TSocGcLrP8LOaWoq8gRTaM4iH8ZVnpCY4Q6+4JrChVbo6tZiGJ7mlwWY+pIXIKwDO13gQ9UPjjb37RRR6mmXH3Ei3mxJnbVWqoVyrZj7K6yGi0/v29HPNcB9mytC5ZtaikpHnzRE7Oj/74RrRXJMd/vzrQRM/PgRRpIcMpy9j3qWaTr0Y+5oJoNRPBv5lJhiRC+t6QPHSNX7qgyaePnJGSa2WqAjM6icnn9nnJpJxn7ShNS+4pMo+QkkTj5uiD0GwzQLJMNu1KlWkzghFnT7XAZU9Bs13IOfrmz7hmdMPTnZQivtaw+Q0BobmvCy/0we4mvVkN7Ai2rD1zvEQY+9Hu3prxAGSWY5UA5VJ9olBSU7B9xaewaFYKcTe1EaPjk3MAmRSBCpL9cqgJzm/HsrS537aFJFmnH7uJ+7OD9vT0EKL4wGOTSKutQFMh5/IKjd3c9p2dBpmd7L37866/0nBRRNqqn1vXlru3WeuuQJQewvQ66vyHLFxvh7qio+S3Ya4g3vZQDGhGBd8jRUovZ6q5pMCYH/KWCT40vn8VlwfzOkiGTOHiO2apYk7uZuUR3rW2q66rZELVrandp9fKKvegigfRVD9AyorEoGYgmtiTfTMXPxEHV7Nzs60Z/ConZ7M6S24zjwBgDEDaPy7TgLQYt/LhCgSgXNLLbnj2rVp9+frAcOjTzSzmg6jgyPpclRi+5/QfC8V4TSjkhvNXEoOX1nb0zsmH+oOpSvODw7EQSWjKH4wZt4PzTwzDG15X0WAln+sDdlj7TRxD5LBuLQR171ApNxgnbWOSqf1/OC+EHtzZATziPX88uzOsSU1FdJtmlDWBEkTxPwSVoKsoVqDYS4EvQQBPnp5dv8iIWetfUM3vuxxdOt9UUS1CAIZUv2V5QoQGt8k0u+CMwx8UKT+cnsnHG1j/cPnI4Fr+97nrk8+Mt3RD43yL8O0jn3Q/pwm/kgT5G+w/f7uZ9a/uoa26/bbr3IvoJTv51Yicyv0kvF/mCb27feAMC3HdWlk5++0fhP1Pmm/TxO3Cz/YbBfAT5r4+Tzlg3abPwB4/lBc/uvnOCx5ia5/lrXHD+SH/fUt2/4dSK+K//M+8YmJsOR3/7v3hnAI4pcY+z806Yf8g6JT/iziffvbg+hNNtf/CBDLhOr/YjOYvz2IW0uywb89iGiS/tGB/Q/HQPbpCQKfDQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group 1.30a574454ad5263d3c3825e3f7500e23.svg";
export { ForwardRef as ReactComponent };